export const searchTextAutoCompleteDescription = "PrliQd";
export const searchTextAutoCompleteTabHint = "$VZEad";
export default {searchTextAutoCompleteDescription,searchTextAutoCompleteTabHint};